var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "fill-height align-start" },
    [
      _c(
        "v-row",
        {
          attrs: {
            align: _vm.isEmpty || _vm.isLoading ? "center" : "start",
            justify: _vm.isEmpty || _vm.isLoading ? "center" : "start",
          },
        },
        [
          _c(
            "v-btn",
            {
              attrs: {
                fab: "",
                bottom: "",
                right: "",
                fixed: "",
                large: "",
                color: "primary",
              },
              on: {
                click: function ($event) {
                  return _vm.$router.push({ name: "userNew" })
                },
              },
            },
            [_c("v-icon", [_vm._v("mdi-plus")])],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-data-table", {
                attrs: {
                  dense: "",
                  headers: _vm.headers,
                  items: _vm.users,
                  loading: _vm.isLoading,
                  "items-per-page": _vm.itemsPerPage,
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.actions",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "", small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.gotoUserEdit(item.id)
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-pencil")])],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "", small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteUser(item)
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-delete")])],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }